import { StatoImpianto } from '@/models/dto/impianto/stato-impianto'
import { FacilityStatus } from '@/models/types/facility/facility-status'

const mapToFacilityStatus = (statoImpianto: StatoImpianto | null | undefined): FacilityStatus => {
    switch (statoImpianto) {
        case StatoImpianto.OK: {
            return FacilityStatus.OK
        }
        case StatoImpianto.WARNING: {
            return FacilityStatus.WARNING
        }
        case StatoImpianto.ERROR: {
            return FacilityStatus.ERROR
        }
        default: {
            return FacilityStatus.OK
        }
    }
}

const mapToStatoImpianto = (facilityStatus: FacilityStatus | undefined): StatoImpianto => {
    switch (facilityStatus) {
        case FacilityStatus.OK: {
            return StatoImpianto.OK
        }
        case FacilityStatus.WARNING: {
            return StatoImpianto.WARNING
        }
        case FacilityStatus.ERROR: {
            return StatoImpianto.ERROR
        }
        default: {
            return StatoImpianto.OK
        }
    }
}

export { mapToFacilityStatus, mapToStatoImpianto }
